// var languageType = require('./languageCommon.js')
var languageType = require('./languageCommon.js')
var language = localStorage.getItem('language') || 'zh-CN'
if(window.location.search.indexOf('lang=En')>-1){
    language='USA';
    localStorage.setItem('language','USA')
}

$('.commonlanguage').html(commonlanguage[language])
$('title').html(homePageTitle[language]);
$('.commonHomePage').html(commonHomePage[language]);
$('.commonLvyue').html(commonLvyue[language]);
$('.commonAboutLvyue').html(commonAboutLvyue[language]);
$('.commonflowerTravel').html(commonflowerTravel[language]);
$('.commonlvyueBrand').html(commonlvyueBrand[language]);
$('.commonFlowerConstruction').html(commonFlowerConstruction[language]);
$('.commonFloralLux').html(commonFloralLux[language]);
$('.commonClaim').html(commonClaim[language]);
$('.commonClaimChoice').html(commonClaimChoice[language]);
$('.commonWeiLai').html(commonWeiLai[language]);
$('.commonTanChen').html(commonTanChen[language]);
$('.commonBaina').html(commonBaina[language]);
$('.commonBanlan').html(commonBanlan[language]);
$('.commonBeu').html(commonBeu[language]);
$('.subhtml').html(subhtml[language]);
$('.commonJoinInCooperation').html(commonJoinInCooperation[language]);
$('.commonPanorama').html(commonPanorama[language]);
// $('.commonPaidInformation').html(commonPaidInformation[language]);
$('.commonZh').html(commonZh[language]);
$('.commonUsa').html(commonUsa[language]);
$('.commonJp').html(commonJp[language]);
$('.commonKo').html(commonKo[language]);
$('.commonTh').html(commonTh[language]);
$('.commonYh').html(commonYh[language]);
$('.commonReservations a').html(commonReservations[language]);
$('.commonClose').html(commonClose[language]);
$('.commonFreebooking').html(commonFreebooking[language]);
$('.commonDownload').html(commonDownload[language]);
$('.commonWechatSubscription').html(commonWechatSubscription[language]);
$('.commonHuazhuSubscription').html(commonHuazhuSubscription[language]);
$('.commonBrandintroductio').html(commonBrandintroductio[language]);
$('.commonWantJoin').html(commonWantJoin[language]);
$('.commonConectUs').html(commonConectUs[language]);
$('.commonCustomerServiceHotline').html(commonCustomerServiceHotline[language]);
$('.commonConectChina').html(commonCustomerServiceHotlineChina[language]);
$('.commonConectPhilippines').html(commonCustomerServiceHotlinePhilippines[language]);
$('.commonConectJapan').html(commonCustomerServiceHotlineJapan[language]);
$('.commonConectKorea').html(commonCustomerServiceHotlineKorea[language]);
$('.commonConectThailand').html(commonCustomerServiceHotlineThailand[language]);
$('.commonConectYh').html(commonCustomerServiceHotlineYh[language]);
$('.commonCompanyInfo').html(commonCompanyInfo[language]);
$('.commonCompanyBeianInfo').html(commonCompanyBeianInfo[language]);
$('.commonCompanyBeianText').html(commonCompanyBeianText[language]);
$('.commonCompanyLicense').html(commonCompanyLicense[language]);
$('.commonCompanyICP').html(commonCompanyICP[language]);
$('.homePageSwiperOneTitle').html(homePageSwiperOneTitle[language]);
$('.homePageSwiperTwoTitle').html(homePageSwiperTwoTitle[language]);
$('.homePageSwiperThreeTitle').html(homePageSwiperThreeTitle[language]);
$('.homePageSwiperThreeInfo').html(homePageSwiperThreeInfo[language]);
$('.homePageSwiperThreeOpenedArea').html(homePageSwiperThreeOpenedArea[language]);
$('.homePageSwiperTobeOpenedArea').html(homePageSwiperTobeOpenedArea[language]);
$('.homePageSwiperThreeKohSamui').html(homePageSwiperThreeKohSamui[language]);
$('.homePageSwiperThreeBeijing').html(homePageSwiperThreeBeijing[language]);
$('.homePageSwiperThreeNanjing').html(homePageSwiperThreeNanjing[language]);
$('.homePageSwiperThreeMoganmountain').html(homePageSwiperThreeMoganmountain[language]);
$('.homePageSwiperThreeNanxun').html(homePageSwiperThreeNanxun[language]);
$('.homePageSwiperThreeAnji').html(homePageSwiperThreeAnji[language]);
$('.homePageSwiperThreeChiangmai').html(homePageSwiperThreeChiangmai[language]);
$('.homePageSwiperThreeSeoul').html(homePageSwiperThreeSeoul[language]);
$('.homePageSwiperThreeXishuangbanna').html(homePageSwiperThreeXishuangbanna[language]);
$('.homePageSwiperThreeDali').html(homePageSwiperThreeDali[language]);
$('.homePageSwiperThreeLijiang').html(homePageSwiperThreeLijiang[language]);
$('.homePageSwiperThreeChongqie').html(homePageSwiperThreeChongqie[language]);
$('.homePageSwiperThreeLangzhonge').html(homePageSwiperThreeLangzhonge[language]);
$('.homePageSwiperThreeGuohuang').html(homePageSwiperThreeGuohuang[language]);
$('.homePageSwiperThreeLibo').html(homePageSwiperThreeLibo[language]);
$('.homePageSwiperThreeZhangjiajie').html(homePageSwiperThreeZhangjiajie[language]);
$('.homePageSwiperThreeHuangshan').html(homePageSwiperThreeHuangshan[language]);
$('.homePageSwiperThreeHangzhou').html(homePageSwiperThreeHangzhou[language]);
$('.homePageSwiperThreeChejudo').html(homePageSwiperThreeChejudo[language]);
$('.homePageSwiperThreeFenghuang').html(homePageSwiperThreeFenghuang[language]);
$('.homePageSwiperThreeSemporna').html(homePageSwiperThreeSemporna[language]);
$('.homePageSwiperThreeWuzhen').html(homePageSwiperThreeWuzhen[language]);
$('.homePageSwiperThreeSuzhou').html(homePageSwiperThreeSuzhou[language]);
$('.homePageSwiperThreeGuilin').html(homePageSwiperThreeGuilin[language]);
$('.homePageSwiperThreeWulong').html(homePageSwiperThreeWulong[language]);
$('.homePageSwiperThreeXian').html(homePageSwiperThreeXian[language]);
$('.homePageSwiperThreePingyao').html(homePageSwiperThreePingyao[language]);
$('.homePageSwiperThreeXiamen').html(homePageSwiperThreeXiamen[language]);
$('.homePageSwiperThreeLishui').html(homePageSwiperThreeLishui[language]);
$('.homePageSwiperThreeXitang').html(homePageSwiperThreeXitang[language]);
$('.homePageSwiperThreeSingapore').html(homePageSwiperThreeSingapore[language]);
$('.homePageSwiperThreeKualaLumpur').html(homePageSwiperThreeKualaLumpur[language]);
$('homePageSwiperThreePenang').html(homePageSwiperThreePenang[language]);
$('.homePageSwiperThreePhuket').html(homePageSwiperThreePhuket[language]);
$('.homePageSwiperThreeLangkawi').html(homePageSwiperThreeLangkawi[language]);
$('.homePageSwiperThreePhnomPenh').html(homePageSwiperThreePhnomPenh[language]);
$('.homePageSwiperThreeKotaKinabalu').html(homePageSwiperThreeKotaKinabalu[language]);
$('.homePageSwiperThreePattaya').html(homePageSwiperThreePattaya[language]);
$('.homePageSwiperThreeBangkok').html(homePageSwiperThreeBangkok[language]);
$('.homePageSwiperThreeSiemReap').html(homePageSwiperThreeSiemReap[language]);
$('.homePageSwiperThreeNhaTrang').html(homePageSwiperThreeNhaTrang[language]);
$('.homePageSwiperThreeDaNang').html(homePageSwiperThreeDaNang[language]);
$('.homePageSwiperThreeCebu').html(homePageSwiperThreeCebu[language]);
$('.homePageSwiperThreeBoracayIsland').html(homePageSwiperThreeBoracayIsland[language]);
$('.homePageSwiperThreeManila').html(homePageSwiperThreeManila[language]);
$('.homePageSwiperThreeHanoi').html(homePageSwiperThreeHanoi[language]);
$('.homePageSwiperThreeHongKong').html(homePageSwiperThreeHongKong[language]);
$('.homePageSwiperThreeKaohsiung').html(homePageSwiperThreeKaohsiung[language]);
$('.homePageSwiperThreeHualian').html(homePageSwiperThreeHualian[language]);
$('.homePageSwiperThreeTaipei').html(homePageSwiperThreeTaipei[language]);
$('.homePageSwiperThreeTengchong').html(homePageSwiperThreeTengchong[language]);
$('.homePageSwiperThreeShangriLa').html(homePageSwiperThreeShangriLa[language]);
$('.homePageSwiperThreeWuyiMount').html(homePageSwiperThreeWuyiMount[language]);
$('.homePageSwiperThreeJiaxing').html(homePageSwiperThreeJiaxing[language]);
$('.homePageSwiperThreeRizhao').html(homePageSwiperThreeRizhao[language]);
$('.homePageSwiperThreeBusan').html(homePageSwiperThreeBusan[language]);
$('.homePageSwiperThreeRizhao').html(homePageSwiperThreeRizhao[language]);
$('.homePageSwiperThreeOsaka').html(homePageSwiperThreeOsaka[language]);
$('.homePageSwiperThreeTokyo').html(homePageSwiperThreeTokyo[language]);
$('.homePageSwiperThreekyoto').html(homePageSwiperThreekyoto[language]);
$('.homePageSwiperThreeXinzhou').html(homePageSwiperThreeXinzhou[language]);
$('.homePageSwiperFourTitle').html(homePageSwiperFourTitle[language]);
$('.homePageSwiperFourBrandintroduction').html(homePageSwiperFourBrandintroduction[language]);
$('.homePageSwiperFourDesignidea').html(homePageSwiperFourDesignidea[language]);
$('.homePageSwiperFourDesignideaInfo1').html(homePageSwiperFourDesignideaInfo1[language]);
$('.homePageSwiperFourSite').html(homePageSwiperFourSite[language]);
$('.homePageSwiperFourView').html(homePageSwiperFourView[language]);
$('.homePageSwiperFourVacation').html(homePageSwiperFourVacation[language]);
$('.homePageSwiperFourBusinesstrip').html(homePageSwiperFourBusinesstrip[language]);
$('.homePageSwiperFourDesignideaInfo3').html(homePageSwiperFourDesignideaInfo3[language]);
$('.homePageSwiperFourBusinesstrip').html(homePageSwiperFourBusinesstrip[language]);
$('.homePageSwiperFourDesignideaInfo2').html(homePageSwiperFourDesignideaInfo2[language]);
$('.homePageSwiperFourTourismVacationSocialBusiness').html(homePageSwiperFourTourismVacationSocialBusiness[language]);

$('.homePageSwiperFourDesignideaInfo4').html(homePageSwiperFourDesignideaInfo4[language]);
$('.homePageSwiperFourMotto4').html(homePageSwiperFourMotto4[language]);
$('.homePageSwiperFourDesignideaInfo5').html(homePageSwiperFourDesignideaInfo5[language]);
$('.homePageSwiperFourMotto5').html(homePageSwiperFourMotto5[language]);
$('.homePageSwiperFourDesignideaInfo6').html(homePageSwiperFourDesignideaInfo6[language]);
$('.homePageSwiperFourDesignideaInfo7').html(homePageSwiperFourDesignideaInfo7[language]);
$('.homePageSwiperFourMotto6').html(homePageSwiperFourMotto6[language]);
$('.homePageSwiperFourMotto7').html(homePageSwiperFourMotto7[language]);


$('.homePageSwiperFiveJointheInformation').html(homePageSwiperFiveJointheInformation[language]);
$('.homePageSwiperFiveJointheInformation').attr('placeholder',homePageSwiperFiveJointheInformation[language]);
$('.homePageSwiperFiveGirl').html(homePageSwiperFiveGirl[language]);
$('.homePageSwiperFiveBoy').html(homePageSwiperFiveBoy[language]);
$('.homePageSwiperFiveInputPhone').attr('placeholder',homePageSwiperFiveInputPhone[language]);
$('.homePageSwiperFiveInputPhone').attr('datavalue',homePageSwiperFiveInputPhone[language]);
$('.homePageSwiperFiveInputSpace').attr('placeholder',homePageSwiperFiveInputSpace[language]);
$('.homePageSwiperFiveInputSpace').attr('datavalue',homePageSwiperFiveInputSpace[language]);
$('.homePageSwiperFiveJoin').html(homePageSwiperFiveJoin[language]);
$('.homePageSwiperFiveMaterialcooperation').html(homePageSwiperFiveMaterialcooperation[language]);
$('.homePageSwiperFiveJoinRemarkTips').attr('placeholder',homePageSwiperFiveJoinRemarkTips[language]);
$('.homePageSwiperFiveJoinRemarkTips').attr('datavalue',homePageSwiperFiveJoinRemarkTips[language]);
$('.homePageSwiperFiveInputName').attr('placeholder',homePageSwiperFiveInputName[language]);
$('.homePageSwiperFiveJoinRemarkTips').attr('datavalue',homePageSwiperFiveInputName[language]);
$('.homePageSwiperFiveInputName').html(homePageSwiperFiveInputName[language]);
$('.homePageSwiperThreePenang').html(homePageSwiperThreePenang[language])
$('.commonLvyue1').html(commonLvyue1[language]);
$('.Leadership').html(Leadership[language]);
$('.TalentRecruitment').html(TalentRecruitment[language]);
$('.floralReservation').html(floralReservation[language]);

$('.commonBaina').html(commonBaina[language]);
$('.commonBanlan').html(commonBanlan[language]);



/** WEBPACK FOOTER **
 ** ./src/js/indexLanguage.js
 **/